import { logStyles } from './LogStyles';
import Swal from 'sweetalert2';

function formatarData(valor) {
  try {
    return new Date(valor).toLocaleString('pt-BR');
  } catch {
    return valor;
  }
}

export function mostrarLogs(logs = []) {
  if (!logs.length) {
    Swal.fire({
      icon: 'info',
      title: 'Logs',
      text: 'Nenhum log disponível',
    });
    return;
  }

  const logsContainer = document.createElement('div');
  Object.assign(logsContainer.style, logStyles.container);

  logs.forEach((log) => {
    const logBlock = document.createElement('div');
    Object.assign(logBlock.style, logStyles.logBlock);

    // 🔹 Cabeçalho (UPLOAD / CANCELAMENTO / etc)
    const titulo = log.type || log.acao;
    if (titulo) {
      const titleEl = document.createElement('div');
      titleEl.textContent = titulo;
      titleEl.style.fontWeight = 'bold';
      titleEl.style.marginBottom = '6px';
      titleEl.style.fontSize = '14px';
      logBlock.appendChild(titleEl);
    }

    Object.entries(log).forEach(([key, value]) => {
      if (key === 'type' || key === 'acao') return;

      const field = document.createElement('div');
      Object.assign(field.style, logStyles.logField);

      const label = document.createElement('span');
      label.textContent = `${key}: `;
      Object.assign(label.style, logStyles.label);
      field.appendChild(label);

      // 🔹 USUÁRIO (objeto)
      if (key === 'user' && value?.name) {
        const valueSpan = document.createElement('span');
        valueSpan.textContent = value.name;
        Object.assign(valueSpan.style, logStyles.user);
        field.appendChild(valueSpan);
      }

      // 🔹 DATA
      else if (key.toLowerCase().includes('data')) {
        const valueSpan = document.createElement('span');
        valueSpan.textContent = formatarData(value);
        Object.assign(valueSpan.style, logStyles.data);
        field.appendChild(valueSpan);
      }

      // 🔹 META (objeto genérico)
      else if (typeof value === 'object' && value !== null) {
        const metaContainer = document.createElement('div');
        metaContainer.style.marginLeft = '12px';
        metaContainer.style.marginTop = '4px';

        Object.entries(value).forEach(([metaKey, metaValue]) => {
          const metaLine = document.createElement('div');
          metaLine.textContent = `• ${metaKey}: ${metaValue ?? '-'}`;
          metaLine.style.fontSize = '13px';
          metaLine.style.opacity = '0.85';
          metaContainer.appendChild(metaLine);
        });

        field.appendChild(metaContainer);
      }

      // 🔹 TEXTO SIMPLES
      else {
        const valueSpan = document.createElement('span');
        valueSpan.textContent = value ?? '-';
        field.appendChild(valueSpan);
      }

      logBlock.appendChild(field);
    });

    logsContainer.appendChild(logBlock);
  });

  Swal.fire({
    title: '📋 Histórico do Documento',
    html: logsContainer.outerHTML,
    showCloseButton: true,
    showConfirmButton: false,
    width: 850,
  });
}
